
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {LibraryLayout} from '../../components/Library'

export const metadata = {
  "title": "Hyper Meta: a week of Hyperlink events",
  "date": "2021-06-03",
  "author": "Brendan",
  "toc": true,
  "living": false,
  "tags": ["announcement"],
  "description": "A series of events exploring courses, learning clubs & other experiments.",
  "topic": ""
};

const layoutProps = {
  metadata
};
const MDXLayout = ({children}) => <LibraryLayout {...metadata}>{children}</LibraryLayout>
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><strong parentName="p">{`Hyper Meta is a series of Hyperlink-hosted events, exploring courses, learning clubs & other experiments.`}</strong></p>
    <p>{`We're starting with a week of free events, from June 7–11.`}</p>
    <p>{`Get to know the Hyperlink founding team, meet other creators, and workshop your ideas for courses and clubs.`}</p>
    <p>{`Oh, and be among the first to test out `}<strong parentName="p">{`Hyperspace`}</strong>{`, our new collaborative learning environment. A space for shared learning, digital gardening, and doing things together.`}</p>
    <p>{`Please join any or all of the events; they're free and open to all. However, to help us prepare, please only RSVP if you're sure you can make it!`}</p>
    <h3 {...{
      "id": "hyper-meta-future-of-peer-learning-clubs"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/events/602"
      }}>{`Hyper Meta: Future of Peer Learning Clubs`}</a></h3>
    <p>{`Explore how you can start a learning club — emergent and collaborative p2p cohorts — and how we might experiment together with new forms for peer-driven learning.`}</p>
    <p>{`Brendan and Adam will host, joined by several others who have hosted awesome clubs ranging from writing to language learning to comics creation.`}</p>
    <p>{`Monday, June 7, FREE`}</p>
    <h3 {...{
      "id": "hyper-meta-course-creator-canvas"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/events/603"
      }}>{`Hyper Meta: Course Creator Canvas`}</a></h3>
    <p>{`Workshop your course idea together, in a condensed version of the first week of our Meta Course. We'll start with a rough idea, plot goals and construct a concept map, and start to plan a potential course structure.`}</p>
    <p>{`Hosted by Brendan and Celine. After, we can set you up with a draft course and talk further about launching a course on Hyperlink!`}</p>
    <p>{`Tuesday, June 8, FREE`}</p>
    <h3 {...{
      "id": "hyper-meta-how-to-book-club"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/events/604"
      }}>{`Hyper Meta: How To Book Club`}</a></h3>
    <p>{`Let's talk about book clubs — how to start them, how to run them, and how we can experiment with future book club possibilities.`}</p>
    <p>{`Brendan will be co-hosting along with Emily of Italic Type, to talk about the benefits of book clubs for learning, how to run an impactful group, and how we can experiment with new ways of engaging with books and each other.`}</p>
    <p>{`Wednesday, June 9, FREE`}</p>
    <h3 {...{
      "id": "hyper-meta-pedagogical-pattern-playground"
    }}><a parentName="h3" {...{
        "href": "https://hyperlink.academy/events/605"
      }}>{`Hyper Meta: Pedagogical Pattern Playground`}</a></h3>
    <p>{`Join Brendan and Jared of Hyperlink to experiment with building a "pattern language" for teaching and learning.`}</p>
    <p>{`We'll extend existing pedagogical patterns, play with new possibilities for shaping learning experiences — for facilitation, activities, discussion and more — particularly in collaborative contexts and emergent internet modes.`}</p>
    <p>{`Thursday, June 10, FREE`}</p>
    <h3 {...{
      "id": "hyperlink-nyc-meetup"
    }}>{`Hyperlink NYC Meetup`}</h3>
    <p>{`A celebration of Hyperlink's first year, and the soft/beta launch of Hyperspace — we'll meet up in person, talk learning, and hang on Brendan's roof deck :)`}</p>
    <p>{`This is an offline event with limited capacity. If you're a friend of Hyperlink and interested in dropping by Friday afternoon in Prospect Heights, Brooklyn, let us know and we'll send details!`}</p>
    <p>{`Friday, June 11, FREE`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;